import React, { useState } from 'react';
import { FadeIn } from '../ui/FadeIn';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Es difícil de seguir?',
    a: 'No, son ingredientes que compras en cualquier supermercado hispano.'
  }, {
    q: '¿Sirve si ya me operaron?',
    a: 'Sí, ayuda a proteger las articulaciones que aún tienes sanas y acelera la recuperación.'
  }, {
    q: '¿Tengo que dejar mis medicinas?',
    a: 'No, este plan es un apoyo natural; tu médico decidirá cuándo bajarte la dosis al ver tu mejoría.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-6 bg-brand-cream" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <FadeIn data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-4">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-5">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-6">
              <div className="bg-white rounded-2xl shadow-sm border border-brand-creamDark overflow-hidden" data-id="element-7">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-8">
                  <span className="font-bold text-xl pr-4" data-id="element-9">{faq.q}</span>
                  <ChevronDownIcon className={`w-6 h-6 text-brand-gold transition-transform duration-300 ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-10" />
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-11">
                  <p className="text-brand-brown/80" data-id="element-12">{faq.a}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}